// BillCoverageType values, hand-synched w/ PortCall.Models\Billing\BillCoverage.cs.
export enum BillCoverageType {
    JobOrder               = 'JO',
    DispatchEvent          = 'DE',
}



// WEBPACK FOOTER //
// ./data/models/BillCoverageType.ts